import { render } from "./table.vue?vue&type=template&id=5a9d5aa8&scoped=true"
import script from "./table.vue?vue&type=script&lang=ts"
export * from "./table.vue?vue&type=script&lang=ts"

import "./table.vue?vue&type=style&index=0&id=5a9d5aa8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5a9d5aa8"

export default script